export default __webpack_public_path__ + "static/media/P943_RoHS.db23043a.pdf";